import { Skeleton } from '@/components/ui/skeleton';

/**
 * Fallback padrão de `<Suspense>` para páginas carregadas via `React.lazy` (ver App.tsx).
 * Reproduz a anatomia da página real (Breadcrumb → PageHeader → Card, seção 6.1 do
 * docs-arquitetura/13-diretrives-visuais-ux.md.md) só com placeholders, para o layout
 * não "pular" quando o conteúdo real chega. Some assim que o chunk da rota carrega —
 * não é um estado de loading de dados (isso continua sendo o <Skeleton> local de cada
 * página, que já cobre o fetch via react-query).
 */
export function PageSkeleton() {
  return (
    <div className="animate-in fade-in duration-200 space-y-6" aria-hidden>
      {/* Breadcrumb */}
      <Skeleton className="h-4 w-40" />

      {/* PageHeader */}
      <div className="space-y-2 border-b border-border pb-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-9 w-32" />
        </div>
        <Skeleton className="h-4 w-72" />
      </div>

      {/* Card */}
      <div className="rounded-xl border border-border shadow-card">
        <div className="border-b border-border bg-muted p-4">
          <Skeleton className="h-4 w-36" />
        </div>
        <div className="space-y-3 p-4">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
    </div>
  );
}
